import { useAuth } from 'components/providers/AuthProvider'
import { useEffect, useState } from 'react'
import {
  hasUnreadWhatsNew,
  markWhatsNewAsSeen,
  prefetchLatestWhatsNewPost,
  WhatsNewPost
} from 'services/api/whatsNew'
import LocalStorage from 'services/LocalStorage'
import { LocalStorageKey } from 'types/services/localStorage'
import { is24meApp } from 'utils/appType'
import { isCypress } from 'utils/cypress'

import WhatsNewDialog from './WhatsNewDialog'

export default function WhatsNewStartupDialog() {
  const auth = useAuth()
  const [open, setOpen] = useState(false)
  const [posts, setPosts] = useState<WhatsNewPost[]>([])

  useEffect(() => {
    // we also purposely skip for now dialog for 24me
    if (is24meApp()) return

    // in cypress we want to skip startup dialog to prevent tests from running
    if (isCypress()) return

    if (!auth.isAuth) return

    if (auth.isAuth) {
      const rawSessionCounter = LocalStorage.get(
        LocalStorageKey.SESSION_COUNTER
      )
      const sessionCounter = Number(rawSessionCounter ?? 0)
      const nextSessionCounter = Number.isFinite(sessionCounter)
        ? sessionCounter + 1
        : 1
      LocalStorage.set(LocalStorageKey.SESSION_COUNTER, nextSessionCounter)
    }

    const sessionCounter = Number(
      LocalStorage.get(LocalStorageKey.SESSION_COUNTER) ?? 0
    )
    if (!Number.isFinite(sessionCounter) || sessionCounter <= 1) return

    prefetchLatestWhatsNewPost()
      .then((latest) => {
        if (latest && hasUnreadWhatsNew(latest.id)) {
          setPosts([latest])
          setOpen(true)
        }
      })
      .catch((error) => {
        console.error('Error prefetching latest Whats New post:', error)
      })
  }, [auth.isAuth])

  const onClose = () => {
    const latestId = posts[0]?.id
    if (latestId) {
      markWhatsNewAsSeen(latestId)
    }

    setOpen(false)
  }

  return (
    <WhatsNewDialog
      open={open}
      setOpen={setOpen}
      posts={posts}
      loading={false}
      error={null}
      onClose={onClose}
    />
  )
}
